"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStoreLocale = getStoreLocale;
const common_1 = require("../types/common");
const cookie_1 = require("./cookie");
function isStoreCode(str) {
    return Object.values(common_1.Store).includes(str);
}
function isLocale(str) {
    return Object.values(common_1.Locale).includes(str);
}
function getStoreLocaleFromUrl() {
    var _a, _b;
    const pathname = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) !== null && _b !== void 0 ? _b : '';
    const [storeCodeWithLocale] = pathname.split('/').filter(Boolean);
    const [storeCode, locale] = storeCodeWithLocale.split('-');
    return {
        storeCode: isStoreCode(storeCode) ? storeCode : undefined,
        locale: isLocale(locale) ? locale : undefined,
    };
}
function getStoreLocale() {
    const urlData = getStoreLocaleFromUrl();
    const cookies = (0, cookie_1.getCookies)();
    return {
        storeCode: urlData.storeCode || cookies.storeCode || common_1.Store.DE,
        locale: urlData.locale || cookies.locale || common_1.Locale.DE,
    };
}
//# sourceMappingURL=store-locale.js.map